/* eslint-disable prettier/prettier */
import { ChangeEventHandler } from 'react';
import styled, { useTheme } from 'styled-components';
import { Checkmark } from 'shared/icons/Checkmark';

import { variableFontRegular } from 'styles/theme';

export type CheckboxProps = {
  checked: boolean;
  className?: string;
  'data-qa'?: string;
  id: string;
  label?: string;
  labelStyle?: { [key: string]: string | number };
  name: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
  darkTheme?: boolean;
  value?: number | string;
};

export const Checkbox = ({
  checked,
  className,
  'data-qa': dataQa,
  id,
  label,
  labelStyle,
  name,
  onChange,
  darkTheme,
}: CheckboxProps) => {
  const theme = useTheme();
  return (
    <Checkbox.Wrapper className={className} htmlFor={id} aria-label={label} data-qa={dataQa}>
      <Checkbox.Box $darkTheme={darkTheme}>
        {checked && <Checkmark color={theme.navigation.textColor} />}
        <input
          name={name}
          id={id}
          type="checkbox"
          checked={checked}
          onChange={onChange}
        />
        <Checkbox.Control />
      </Checkbox.Box>
      <Checkbox.Label style={labelStyle}>{label}</Checkbox.Label>
    </Checkbox.Wrapper>
  );
};

Checkbox.Box = styled.span<{ $darkTheme: boolean }>`
  display: grid;
  height: 16px;
  width: 16px;
  padding: 3px 2px 1px 2px;
  border: 1px solid ${({ theme }) => theme.navigation.textColor};

  input {
    height: 16px;
    opacity: 0;
    width: 16px;
  }

  input + span::before {
    content: '';
    width: 16px;
    height: 16px;
    box-shadow: inset 12px 12px ${({ theme }) => theme.navigation.textColor};
    border-radius: 0;
    transition: 100ms transform ease-in-out;
    transform: scale(0);
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.small}px) {
    padding: 3px 2px 2px 2px;
  }
`;

Checkbox.Control = styled.span`
  border-radius: 0;
  cursor: pointer;
  height: 0;
  width: 0;
  display: grid;
  place-items: center;
`;

Checkbox.Wrapper = styled.label`
  color: ${({ theme }) => theme.navigation.textColor};
  display: flex;
  gap: 10px;
  align-items: center;

  & div:first-child {
    grid-column: 1;
    grid-row: 1;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.small}px) {
    font-size: 11.5px;
  }

  p {
    padding-top: 2px;
  }
`;

Checkbox.Label = styled.p`
  color: ${({ theme}) => theme.navigation.textColor};
  margin: 0;
  ${variableFontRegular({ size: '11px', height: '14px' })};
`;
